<ng-container [ngSwitch]="stepNumber">
    <!-- WELCOME 1 -->
    <ng-template [ngSwitchCase]="0">
        <div class="step-form">
            <div class="form-card text-center p-5" style="border: none; background: transparent; box-shadow: none;">
                <div class="mb-5 welldone-header">
                    <img src="assets/logo-icon.svg" alt="Welldone Logo" class="welldone-logo">
                    <h1 class="welldone-title">
                        WELL DONE
                    </h1>
                </div>

                <h1 class="mb-4" style="font-weight: 800; font-size: 1.5rem; color: #5E6278;">
                    Benvenuto nell'area di onboarding
                </h1>

                <p class="mb-5" style="font-size: 1.5rem; font-weight: 600; color: #5E6278;">
                    Iniziamo la compilazione<br>della richiesta
                </p>

                <button class="btn-procedi" (click)="nextStep()" style="min-width: 200px;">
                    Procedi
                </button>
            </div>
        </div>
    </ng-template>

    <!--STEP 1: Agent Type Selection-->
    <ng-template [ngSwitchCase]="1">
        <div class="step-text">
            <h2 class="step-title">
                Seleziona la tipologia di <span class="gradient-text">agente</span>
            </h2>
            <span class="step-subtitle"><i class="bi bi-person-badge"></i> Scegli la tipologia che meglio descrive la
                tua attività.</span>
        </div>
        <div class="step-form">
            <div class="row g-4">
                <div class="col-md-6">
                    <div class="card agent-type-card" [class.selected]="newUser.subtype === typesOfAccount[2]"
                         (click)="selectAgentType(typesOfAccount[2])">
                        <div class="card-body">
                            <div class="card-icon">
                                <i class="bi bi-briefcase-fill"></i>
                            </div>
                            <div class="card-text">
                                <h5 class="card-title">Agente di commercio / Enasarco Plus Mandatario</h5>
                                <p class="card-description">Per agenti di commercio e mandatari Enasarco Plus</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card agent-type-card" [class.selected]="newUser.subtype === typesOfAccount[3]"
                         (click)="selectAgentType(typesOfAccount[3])">
                        <div class="card-body">
                            <div class="card-icon">
                                <i class="bi bi-building"></i>
                            </div>
                            <div class="card-text">
                                <h5 class="card-title">Cliente Direzionale con P.IVA</h5>
                                <p class="card-description">Per clienti direzionali con partita IVA</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card agent-type-card agent-type-card-expanded"
                         [class.selected]="newUser.subtype === typesOfAccount[4]"
                         (click)="selectAgentType(typesOfAccount[4])">
                        <div class="card-body">
                            <div class="card-icon">
                                <i class="bi bi-person-fill"></i>
                            </div>
                            <div class="card-text">
                                <h5 class="card-title">Segnalatore occasionale No P.IVA</h5>
                                <p class="card-description">Per segnalatori occasionali senza partita IVA</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="buttons">
            <button class="btn-procedi" [disabled]="!newUser.subtype" (click)="nextStep()">
                Procedi
            </button>
        </div>
    </ng-template>

    <!--STEP 2: Personal Information-->
    <ng-template [ngSwitchCase]="2">
        <div class="step-text">
            <h2 class="step-title">
                Informazioni <span class="gradient-text">Personali</span>
            </h2>
            <span class="step-subtitle"><i class="bi bi-person-fill"></i> Inserisci i tuoi dati anagrafici.</span>
        </div>
        <div class="step-form">
            <div class="form-card">
                <form class="row g-3" #personalInfoForm="ngForm">
                    <div class="col-md-6">
                        <label for="agent-firstname" class="form-label required">Nome</label>
                        <input type="text" class="form-control" id="agent-firstname" [(ngModel)]="newUser.firstName"
                               name="firstName" required #firstName="ngModel"
                               [class.is-invalid]="firstName.invalid && (firstName.dirty || firstName.touched)"
                        >
                        <div class="invalid-feedback">Il nome è obbligatorio.</div>
                    </div>
                    <div class="col-md-6">
                        <label for="agent-lastname" class="form-label required">Cognome</label>
                        <input type="text" class="form-control" id="agent-lastname" [(ngModel)]="newUser.lastName"
                               name="lastName" required #lastName="ngModel"
                               [class.is-invalid]="lastName.invalid && (lastName.dirty || lastName.touched)"
                        >
                        <div class="invalid-feedback">Il cognome è obbligatorio.</div>
                    </div>
                    <div class="col-md-6">
                        <label for="agent-document-number" class="form-label required">Numero Carta Identità</label>
                        <input type="text" class="form-control" id="agent-document-number"
                               [(ngModel)]="newUser.documentNumber" name="documentNumber" required
                               #documentNumber="ngModel"
                               [class.is-invalid]="documentNumber.invalid && (documentNumber.dirty || documentNumber.touched)"
                        >
                        <div class="invalid-feedback">Il numero della carta d'identità è obbligatorio.</div>
                    </div>
                    <div class="col-md-6">
                        <label for="agent-fiscal-code" class="form-label required">Codice Fiscale</label>
                        <input type="text" class="form-control" id="agent-fiscal-code" minlength="16" maxlength="16"
                               [(ngModel)]="newUser.fiscalCode" name="fiscalCode" required pattern="[a-zA-Z0-9]{16}"
                               #fiscalCode="ngModel"
                               [class.is-invalid]="fiscalCode.invalid && (fiscalCode.dirty || fiscalCode.touched)"
                        >
                        <div class="invalid-feedback">
                            <span *ngIf="fiscalCode.errors?.['required']">Il codice fiscale è obbligatorio.</span>
                            <span *ngIf="fiscalCode.errors?.['pattern'] || fiscalCode.errors?.['minlength']">Il codice
                                fiscale deve essere di esattamente 16 caratteri alfanumerici.</span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label required">Fronte carta d'identità</label>
                        <div class="rounded-xl border-2 border-dashed bg-slate-50 px-3 py-4 text-center text-sm text-slate-600 hover:bg-slate-100 transition cursor-pointer"
                             [class.border-danger]="!agentDocumentFront" [class.border-success]="agentDocumentFront"
                             [class.border-slate-300]="agentDocumentFront" (click)="frontInput.click()"
                             (dragover)="$event.preventDefault()" (drop)="onDocumentDrop($event, 'front')">
                            <div class="fw-semibold mb-1">
                                Clicca o trascina qui il documento
                            </div>
                            <div class="text-muted small" *ngIf="!agentDocumentFront">
                                Formati supportati: JPG, PNG, PDF
                            </div>
                            <div class="text-success small fw-semibold" *ngIf="agentDocumentFront">
                                ✅ {{ agentDocumentFront.name }}
                            </div>
                        </div>
                        <div class="text-danger small mt-1" *ngIf="!agentDocumentFront">
                            Il fronte della carta d'identità è obbligatorio.
                        </div>
                        <input #frontInput type="file" class="d-none" id="agent-birthdate"
                               accept="image/*,application/pdf" (change)="chooseDocumentFront($event)" required/>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label required">Retro carta d'identità</label>
                        <div class="rounded-xl border-2 border-dashed bg-slate-50 px-3 py-4 text-center text-sm text-slate-600 hover:bg-slate-100 transition cursor-pointer"
                             [class.border-danger]="!agentDocumentBack" [class.border-success]="agentDocumentBack"
                             [class.border-slate-300]="agentDocumentBack" (click)="backInput.click()"
                             (dragover)="$event.preventDefault()" (drop)="onDocumentDrop($event, 'back')">
                            <div class="fw-semibold mb-1">
                                Clicca o trascina qui il documento
                            </div>
                            <div class="text-muted small" *ngIf="!agentDocumentBack">
                                Formati supportati: JPG, PNG, PDF
                            </div>
                            <div class="text-success small fw-semibold" *ngIf="agentDocumentBack">
                                ✅ {{ agentDocumentBack.name }}
                            </div>
                        </div>
                        <div class="text-danger small mt-1" *ngIf="!agentDocumentBack">
                            Il retro della carta d'identità è obbligatorio.
                        </div>
                        <input #backInput type="file" class="d-none" id="agent-birthplace"
                               accept="image/*,application/pdf" (change)="chooseDocumentBack($event)" required/>
                    </div>
                </form>
            </div>
        </div>
        <div class="buttons">
            <div class="btn-back" (click)="previousStep()">
                Indietro
            </div>
            <button class="btn-procedi" [disabled]="!isPersonalInfoValid() || !areDocumentsValid()"
                    (click)="nextStep()">
                Procedi
            </button>
        </div>
    </ng-template>

    <!--STEP 3: Business Information (conditional)-->
    <ng-template [ngSwitchCase]="3">
        <div class="step-text">
            <h2 class="step-title">
                Informazioni <span class="gradient-text">Aziendali</span>
            </h2>
            <span class="step-subtitle"><i class="bi bi-building"></i> Inserisci i dati della tua attività.</span>
        </div>
        <div class="step-form">
            <div class="form-card">
                <form class="row g-3">
                    <div class="col-md-12">
                        <label for="agent-business-name" class="form-label required">Ragione Sociale</label>
                        <input type="text" class="form-control" id="agent-business-name"
                               [(ngModel)]="newUser.businessName" [ngModelOptions]="{standalone: true}"
                        >
                    </div>
                    <div class="col-md-6">
                        <label for="agent-vat" class="form-label required">Partita IVA</label>
                        <input type="text" class="form-control" id="agent-vat" #vat="ngModel" [(ngModel)]="newUser.vat"
                               [ngModelOptions]="{standalone: true}" maxlength="11" pattern=".{0,11}"
                        >
                    </div>
                    <div class="col-md-6">
                        <label for="agent-sdi" class="form-label required">SDI</label>
                        <input type="text" class="form-control" id="agent-sdi" [(ngModel)]="newUser.sdi"
                               [ngModelOptions]="{standalone: true}"/>
                    </div>
                    <div class="col-md-12">
                        <label for="agent-pec" class="form-label">PEC (opzionale)</label>
                        <input type="email" class="form-control" id="agent-pec" [(ngModel)]="newUser.pec"
                               [ngModelOptions]="{standalone: true}" #pec="ngModel" email>
                        <div *ngIf="pec.invalid && (pec.dirty || pec.touched)" class="alert alert-danger mt-2">
                            <div *ngIf="pec.errors?.['email']">
                                Inserisci un indirizzo PEC valido.
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="buttons">
            <div class="btn-back" (click)="previousStep()">
                Indietro
            </div>
            <button class="btn-procedi" [disabled]="!isBusinessInfoValid()" (click)="nextStep()">
                Procedi
            </button>
        </div>
    </ng-template>

    <!--STEP 4: Address & Contact Information-->
    <ng-template [ngSwitchCase]="4">
        <div class="step-text">
            <h2 class="step-title">
                Indirizzo e <span class="gradient-text">Contatti</span>
            </h2>
            <span class="step-subtitle"><i class="bi bi-geo-alt-fill"></i> Inserisci il tuo indirizzo e i tuoi
                contatti.</span>
        </div>
        <div class="step-form">
            <div class="form-card">
                <form class="row g-3" #addressForm="ngForm">
                    <div class="col-md-8">
                        <label for="agent-address" class="form-label required">Indirizzo</label>
                        <input type="text" class="form-control" id="agent-address" [(ngModel)]="newUser.address"
                               name="address" required #address="ngModel"
                               [class.is-invalid]="address.invalid && (address.dirty || address.touched)"
                        >
                        <div class="invalid-feedback">L'indirizzo è obbligatorio.</div>
                    </div>
                    <div class="col-md-4">
                        <label for="agent-address-number" class="form-label required">Numero Civico</label>
                        <input type="text" class="form-control" id="agent-address-number"
                               [(ngModel)]="newUser.addressNumber" name="addressNumber" required
                               #addressNumber="ngModel"
                               [class.is-invalid]="addressNumber.invalid && (addressNumber.dirty || addressNumber.touched)"
                        >
                        <div class="invalid-feedback">Il numero civico è obbligatorio.</div>
                    </div>
                    <div class="col-md-4">
                        <label for="agent-zip" class="form-label required">CAP</label>
                        <input type="text" class="form-control" id="agent-zip" [(ngModel)]="newUser.zip" name="zip"
                               required #zip="ngModel" [class.is-invalid]="zip.invalid && (zip.dirty || zip.touched)"
                        >
                        <div class="invalid-feedback">Il CAP è obbligatorio.</div>
                    </div>
                    <div class="col-md-4">
                        <label for="agent-province" class="form-label required">Provincia</label>
                        <select class="form-control" id="agent-province" [(ngModel)]="newUser.province" name="province"
                                required #province="ngModel"
                                [class.is-invalid]="province.invalid && (province.dirty || province.touched)"
                                (change)="updateCities()">
                            <option value="">Seleziona provincia</option>
                            <option *ngFor="let province of provinces" [value]="province.id">
                                {{ province.name }}
                            </option>
                        </select>
                        <div class="invalid-feedback">La provincia è obbligatoria.</div>
                    </div>
                    <div class="col-md-4">
                        <label for="agent-city" class="form-label required">Città</label>
                        <select class="form-control" id="agent-city" [(ngModel)]="newUser.city" name="city" required
                                #city="ngModel" [class.is-invalid]="city.invalid && (city.dirty || city.touched)">
                            <option value="">Seleziona città</option>
                            <option *ngFor="let city of cities" [value]="city">
                                {{ city }}
                            </option>
                        </select>
                        <div class="invalid-feedback">La città è obbligatoria.</div>
                    </div>
                    <div class="col-md-6">
                        <label for="agent-phone" class="form-label required">Telefono</label>
                        <input type="text" class="form-control" id="agent-phone" [(ngModel)]="newUser.phone"
                               name="phone" required #phone="ngModel" pattern="[0-9+][0-9]*"
                               [class.is-invalid]="phone.invalid && (phone.dirty || phone.touched)"
                        >
                        <div class="invalid-feedback">
                            <span *ngIf="phone.errors?.['required']">Il telefono è obbligatorio.</span>
                            <span *ngIf="phone.errors?.['pattern']">Inserisci un numero di telefono valido (solo
                                numeri).</span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="agent-email" class="form-label required">Email</label>
                        <input type="email" class="form-control" id="agent-email" [(ngModel)]="newUser.email"
                               name="email" required #email="ngModel" email
                               [class.is-invalid]="email.invalid && (email.dirty || email.touched)"
                        >
                        <div class="invalid-feedback">
                            <span *ngIf="email.errors?.['required']">L'email è obbligatoria.</span>
                            <span *ngIf="email.errors?.['email']">Inserisci un indirizzo email valido.</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="buttons">
            <div class="btn-back" (click)="previousStep()">
                Indietro
            </div>
            <button class="btn-procedi" [disabled]="!isAddressContactValid()" (click)="nextStep()">
                Procedi
            </button>
        </div>
    </ng-template>

    <!--STEP 5: Payment Method-->
    <ng-template [ngSwitchCase]="5">
        <div class="step-text">
            <h2 class="step-title">
                Modalità di <span class="gradient-text">pagamento</span>
            </h2>
            <span class="step-subtitle"><i class="bi bi-bank"></i> Area per indicare la modalità di ricezione dei
                pagamenti da parte di Well Done</span>
        </div>
        <div class="step-form">
            <div class="payment-method-card">
                <form class="row g-3" #paymentForm="ngForm">
                    <div class="col-md-6">
                        <label for="agent-bank" class="form-label required">Istituto di credito</label>
                        <input type="text" class="form-control" id="agent-bank" [(ngModel)]="newUser.bank" name="bank"
                               required #bank="ngModel"
                               [class.is-invalid]="bank.invalid && (bank.dirty || bank.touched)"
                        >
                        <div class="invalid-feedback">L'istituto di credito è obbligatorio.</div>
                    </div>
                    <div class="col-md-6">
                        <label for="agent-iban" class="form-label required">IBAN</label>
                        <input type="text" class="form-control text-uppercase" id="agent-iban" [(ngModel)]="newUser.iban" name="iban"
                               required #iban="ngModel" pattern="^IT[0-9A-Z]{25}$"
                               (ngModelChange)="normalizeIban()"
                               [class.is-invalid]="iban.invalid && (iban.dirty || iban.touched)"
                        >
                        <div class="invalid-feedback" *ngIf="iban.invalid && (iban.dirty || iban.touched)">
                            <span *ngIf="iban.errors?.['required']">L'IBAN è obbligatorio.</span>
                            <span *ngIf="iban.errors?.['pattern']">Inserisci un IBAN italiano valido (es. IT00AAAAAAAAAAAAAAAAAAAA).</span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="agent-account-holder-person" class="form-label">Intestatario del C/C (persona
                            fisica)</label>
                        <input type="text" class="form-control" id="agent-account-holder-person"
                               [(ngModel)]="newUser.accountHolderPerson" [ngModelOptions]="{standalone: true}"
                        >
                    </div>
                    <div class="col-md-6">
                        <label for="agent-account-holder-company" class="form-label">Intestatario del C/C
                            (azienda)</label>
                        <input type="text" class="form-control" id="agent-account-holder-company"
                               [(ngModel)]="newUser.accountHolderCompany" [ngModelOptions]="{standalone: true}"
                        >
                    </div>
                    <div class="col-md-6">
                        <label for="agent-payment-phone" class="form-label required">Telefono</label>
                        <input type="text" class="form-control" id="agent-payment-phone"
                               [(ngModel)]="newUser.paymentPhone" name="paymentPhone" required #paymentPhone="ngModel"
                               pattern="[0-9+][0-9]*"
                               [class.is-invalid]="paymentPhone.invalid && (paymentPhone.dirty || paymentPhone.touched)"
                        >
                        <div class="invalid-feedback">
                            <span *ngIf="paymentPhone.errors?.['required']">Il telefono è obbligatorio.</span>
                            <span *ngIf="paymentPhone.errors?.['pattern']">Inserisci un numero di telefono valido (solo
                                numeri).</span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="agent-payment-email" class="form-label required">Email</label>
                        <input type="email" class="form-control" id="agent-payment-email"
                               [(ngModel)]="newUser.paymentEmail" name="paymentEmail" required #paymentEmail="ngModel"
                               email
                               [class.is-invalid]="paymentEmail.invalid && (paymentEmail.dirty || paymentEmail.touched)"
                        >
                        <div class="invalid-feedback">
                            <span *ngIf="paymentEmail.errors?.['required']">L'email è obbligatoria.</span>
                            <span *ngIf="paymentEmail.errors?.['email']">Inserisci un indirizzo email valido.</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="buttons">
            <div class="btn-back" (click)="previousStep()">
                Indietro
            </div>
            <button class="btn-procedi" #nextButton6 [disabled]="!isPaymentMethodValid()" (click)="nextStep()">
                Procedi
            </button>
        </div>
    </ng-template>

    <!--STEP 6: Credentials-->
    <ng-template [ngSwitchCase]="6">
        <div class="step-text">
            <h2 class="step-title">
                Credenziali di <span class="gradient-text">accesso</span>
            </h2>
            <span class="step-subtitle"><i class="bi bi-shield-lock-fill"></i> Crea una password sicura per accedere
                alla tua area riservata.</span>
        </div>
        <div class="step-form">
            <div class="form-card">
                <form class="row g-3">
                    <div class="col-md-12">
                        <label for="agent-password" class="form-label required">Password</label>
                        <div class="input-group">
                            <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="agent-password"
                                   [(ngModel)]="newUser.password" [ngModelOptions]="{standalone: true}"
                            >
                            <button class="btn btn-outline-secondary" (click)="showPassword=!showPassword"
                                    type="button">
                                <i class="fa fa-eye"></i>
                            </button>
                        </div>
                        <div *ngIf="newUser.password && !isPasswordComplexEnough()"
                             class="text-danger mt-1" style="font-size: 0.875rem;">
                            La password deve contenere almeno 8 caratteri, una lettera maiuscola, una minuscola, un
                            numero e un carattere speciale.
                        </div>
                    </div>
                    <div class="col-md-12">
                        <label for="agent-confirm-password" class="form-label required">Conferma password</label>
                        <div class="input-group">
                            <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control"
                                   id="agent-confirm-password" [(ngModel)]="confirmPassword"
                                   [ngModelOptions]="{standalone: true}">
                            <button class="btn btn-outline-secondary" (click)="showConfirmPassword=!showConfirmPassword"
                                    type="button">
                                <i class="fa fa-eye"></i>
                            </button>
                        </div>
                        <div *ngIf="confirmPassword && newUser.password !== confirmPassword"
                             class="invalid-feedback d-block mt-1">
                            Le password non corrispondono.
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="buttons">
            <div class="btn-back" (click)="previousStep()">
                Indietro
            </div>
            <button class="btn-procedi" #nextButton7 [disabled]="!isPasswordValid()" (click)="nextStep()">
                Procedi
            </button>
        </div>
    </ng-template>

    <!--STEP 7: Terms and Conditions-->
    <ng-template [ngSwitchCase]="7">
        <div class="step-text" style="padding-top: 2rem; margin-bottom: 2rem !important;">
            <h2 class="step-title">
                Termini e condizioni del <span class="gradient-text">servizio</span>
            </h2>
            <span class="step-subtitle"><i class="bi bi-file-text"></i> Per completare la registrazione, leggi e accetta
                i termini e condizioni.</span>
        </div>
        <div class="step-form">
            <div class="border rounded-3 p-3 bg-light mb-3">
                <div class="form-check mb-0">
                    <input class="form-check-input" type="checkbox" id="agent-termsandconditions"
                           [(ngModel)]="termsAndConditionAccepted">
                    <label class="form-check-label" for="agent-termsandconditions">
                        * Dichiaro di aver letto, compreso e di accettare i <a href="assets/pdf/terms.pdf" target="_blank"> Termini e condizioni del servizio</a>
                    </label>
                </div>
            </div>
            <div class="border rounded-3 p-3 bg-light mb-3">
                <div class="form-check mb-0">
                    <input class="form-check-input" type="checkbox" id="agent-privacy" [(ngModel)]="privacyAccepted">
                    <label class="form-check-label" for="privacy">
                        * Dichiaro di aver preso visione dell’ <a href="assets/pdf/privacy_agent.pdf" target="_blank"> informatica privacy</a>
                    </label>
                </div>
            </div>
            <div class="border rounded-3 p-3 bg-light mb-3">
                <div class="form-check mb-0">
                    <input class="form-check-input" type="checkbox" id="company-termsandconditions3"
                           [(ngModel)]="agentConditionClauseAccepted">
                    <label class="form-check-label smaller-text ms-1" for="company-termsandconditions3">
                        * Dichiaro di aver preso visione, compreso e dunque di accettare espressamente
                        le seguenti clausole del
                        contratto:<br/>
                        a. Art. 3 servizi, condizioni e modalità di pagamento comma 7;<br/>
                        b. Art. 5. modalità utilizzo account comma 3;<br/>
                        c. Art. 12. esclusione di responsabilità commi 3, 4, 5 e 6;<br/>
                        d. Art. 16 foro delle controversie e legge applicabile.<br/>
                        <br/>
                        <b>Durata contratto:</b> Il presente contratto ha una durata di anni 2 a partire
                        dalla firma.<br/>
                        <b>Disdetta e Rinnovo automatico:</b> Per evitare il rinnovo, il Cliente si
                        impegna a comunicare la
                        disdetta almeno 45 giorni prima della scadenza ai recapiti (PEC/raccomandata
                        a.r.) di New Team. In
                        mancanza di questa comunicazione, il contratto si rinnoverà automaticamente per
                        ulteriori 2 anni.
                        <br/>
                        <br/>
                        * Dichiaro di aver compreso e di sottoscrivere espressamente la clausola Durata
                        e Rinnovo automatico ai
                        sensi degli art. 1341 e 1342 C.C.<br/>
                    </label>
                </div>
            </div>

        </div>
        <div class="buttons">
            <div class="btn-back" (click)="previousStep()">
                Indietro
            </div>
            <button class="btn-procedi" (click)="nextStep()" #nextButton8
                    [disabled]="!(termsAndConditionAccepted && privacyAccepted && agentConditionClauseAccepted)">
                Procedi
            </button>
        </div>
    </ng-template>

    <!--STEP 8: Verification-->
    <ng-template [ngSwitchCase]="8">
        <div class="step-text" style="padding-top: 2rem; margin-bottom: 2rem !important;">
            <h2 class="step-title">
                Verifica <span class="gradient-text">Email</span>
            </h2>
            <span class="step-subtitle"><i class="bi bi-envelope-check"></i> Inserisci il codice OTP che ti abbiamo
                inviato all'indirizzo email <strong>{{ newUser.email }}</strong></span>
        </div>
        <div class="step-form">
            <div class="form-group">
                <label class="form-label required" for="agent-OTP">Codice OTP</label>
                <input type="text" class="form-control form-control-lg text-center" id="agent-OTP" [(ngModel)]="OTPCode"
                       maxlength="6" style="font-size: 1.5rem; letter-spacing: 0.5rem;">
                <small class="form-text text-muted mt-2 d-block">Non hai ricevuto il codice? Controlla la cartella spam
                    o richiedi un nuovo codice.</small>
            </div>
        </div>
        <div class="buttons">
            <div class="btn-back" (click)="previousStep()">
                Indietro
            </div>
            <button class="btn-procedi" (click)="checkOTP(OTPCode, newUser.email)" #nextButton9>
                Verifica e Procedi
            </button>
        </div>
    </ng-template>

    <!--STEP 9: Success-->
    <ng-template [ngSwitchCase]="9">
        <div class="step-text text-center">
            <div class="mb-4">
                <i class="bi bi-check-circle-fill text-success" style="font-size: 4rem;"></i>
            </div>
            <h2 class="step-title">Registrazione completata!</h2>
            <span class="step-subtitle">Congratulazioni, la tua richiesta è stata presa in carico correttamente.</span>
        </div>
        <div class="notice-card mt-4">
            <div class="notice-icon">
                <i class="bi bi-info-circle-fill text-warning fs-2"></i>
            </div>
            <div class="notice-text">
                <h4 class="notice-title">In attesa di approvazione!</h4>
                <div class="notice-description">
                    L'amministrazione Well Done ha preso in carico la sua richiesta. Non appena i dati saranno
                    verificati, riceverete una mail di conferma.
                </div>
            </div>
        </div>
        <div class="buttons d-flex justify-content-center mt-5">
            <div class="btn-procedi" (click)="backToLogin()">Torna al login</div>
        </div>
    </ng-template>
</ng-container>
